<template>
  <div id="email-body" class="email contatto" style="position:absolute;top:0;left:0;"  >
  
      <table cellmargin="0" cellspacing="0" width="760" align="center" border="0" style="border:none;"><tr><td>
  
  
        <table cellmargin="0" cellspacing="0" width="760" align="center"><tr> 
          <td width="100%" align="center">
            <a href="#!" style="margin:10px 0 0 0;"><img src="https://limmsy.biomedia.net/head-simgeped.png" style="width:400px;max-width:400px;border:none;"></a>
          </td>
        </tr></table>
  
  
  
     <table cellmargin="0" cellspacing="0" width="760" align="center"><tr> 
        <td style="margin:0;">
           <br /><br />
           Gentile  {{socio.contatto.row.nome }} {{socio.contatto.row.cognome }}
           <br /><br />
           le confermiamo di aver ricevuto in data {{versamento.eseguitoil | data('DD-MM-YYYY')}} il versamento di {{versamento.importo | money('€ ')}} da lei disposto. 
           <br /><br />
  
           <h4>RIEPILOGO</h4>
           <table cellmargin="0" cellspacing="0" width="760" >
              <tr v-for="(itm,index) in banca" v-bind:key="index" v-if="parseFloat(itm.importo)>0">
                 <td>{{itm.nome}}</td>
                 <td width="150" align="right">{{itm.importo | money('€ ')}}</td>
              </tr>
           </table>
           
           <h4>SITUAZIONE SOCIETARIA</h4>
           <table cellmargin="0" cellspacing="0" width="760" >
              <tr v-for="(itm,index) in socio._si" v-bind:key="index" >
                 <td>{{itm.societa | items($teras._societa,'sigla')}} - {{itm.societa | items($teras._societa,'nome')}}</td>
                 <td width="150" align="right">in regola al {{itm.ultimoanno}}</td>
              </tr>
           </table>
  
  
  
  
           <br /><br />
           Cordiali Saluti 
           <br />
           La segreteria amministrativa 
           <br /><br />
           La ricevuta per l’incasso delle quota associativa è esente dall'imposta di bollo ai sensi dell’art. 7 della Tabella allegata al DPR 642/72
        </td>    
     </tr></table>
  
  
  
  
  
  
    </td ></tr></table>
  </div>
  </template>
  
  <script>
  export default {
     props: ['socio','versamento','banca'],
     created(){
        
     },
     beforeDestroy: function(){
       console.log("VM DISTRUTTA")
     }
  }
  </script>
  